// extracted by css-extract-rspack-plugin
export default {"selectItem":"selectItem-fEC_qg","highlighted":"highlighted-VR0zGa","selected":"selected-uIA9lR","prefix":"prefix-jxbcsz","selectItemText":"selectItemText-UAJcwW text-base-regular"};